import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-your-first-uxp-based-photoshop-plugin"
    }}>{`Creating your first UXP-based Photoshop plugin`}</h1>
    <p>{`In this tutorial, you will create your first own Photoshop plugin using UXP.`}</p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <p>{`To follow this tutorial, you need `}<strong parentName="p">{`Photoshop v23 or above`}</strong>{` and the `}<strong parentName="p">{`UXP Developer Tool (UDT)`}</strong>{`. You can
install both applications with the Creative Cloud Desktop app. You also need `}<strong parentName="p">{`basic knowledge of HTML and JavaScript`}</strong>{`.`}</p>
    <h2 {...{
      "id": "step-1-create-the-plugin"
    }}>{`Step 1: Create the plugin`}</h2>
    <p>{`Open the UXP Developer Tool and click the `}<em parentName="p">{`"Create plugin..."`}</em>{` button. In the dialog that opens, enter the following
details:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Plugin Name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`My first plugin`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Plugin Id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`my.first.plugin`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Plugin Version`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.0.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Host Application`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Adobe Photoshop`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Host Application Version`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`23.0.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Template`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ps-starter`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Click `}<em parentName="p">{`"Select Folder"`}</em>{` and select a new, empty folder where you want to develop your plugin. The Developer Tool creates
the necessary files in your selected folder and adds the plugin to the list of plugins.`}</p>
    <p>{`You should now be able to see the following files in your selected folder:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`icons`}</inlineCode>{`: a folder containing a set of icons for your plugin`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`index.html`}</inlineCode>{`: your plugin's entrypoint. This gets loaded when the plugin loads`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`manifest.json`}</inlineCode>{`: a file containing the metadata you specified in UDT as well as a pointer to the `}<inlineCode parentName="li">{`index.html`}</inlineCode>{` as an
entrypoint.`}</li>
    </ul>
    <p>{`As well as some other "meta" files like `}<inlineCode parentName="p">{`LICENSE`}</inlineCode>{`, `}<inlineCode parentName="p">{`README.md`}</inlineCode>{`, etc.`}</p>
    <h2 {...{
      "id": "step-2-run-the-plugin"
    }}>{`Step 2: Run the plugin`}</h2>
    <p>{`Open Adobe Photoshop and create some sample file you can use with your plugin.`}</p>
    <p>{`To run your plugin within Photoshop, click the `}<em parentName="p">{`"•••"`}</em>{` button on the right of your plugin's row within the UDT and select `}<em parentName="p">{`"
Load"`}</em>{`. This loads your plugin in Photoshop and automatically opens the plugin's panel.`}</p>
    <p>{`The `}<em parentName="p">{`ps-starter`}</em>{` template initially contains a panel with a `}<em parentName="p">{`"Populate Layers"`}</em>{` button that allows you to populate a box
within the panel with the layer names:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "245px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "148.97959183673467%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/ce4e1de7693cacd5bee67f4ddbd82ed1/4530e/panel-base.webp 245w"],
            "sizes": "(max-width: 245px) 100vw, 245px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/ce4e1de7693cacd5bee67f4ddbd82ed1/86a2e/panel-base.png 245w"],
            "sizes": "(max-width: 245px) 100vw, 245px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/ce4e1de7693cacd5bee67f4ddbd82ed1/86a2e/panel-base.png",
            "alt": "A Photoshop panel with a list of layer names and a button called \"Populate Layers\"",
            "title": "A Photoshop panel with a list of layer names and a button called \"Populate Layers\"",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Let's take a look at what's going on in the background when running this plugin.`}</p>
    <p>{`In the `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` file, the `}<inlineCode parentName="p">{`"main"`}</inlineCode>{` field points to the `}<inlineCode parentName="p">{`index.html`}</inlineCode>{` file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "id": "my.first.plugin",
  "name": "My first plugin",
  "version": "1.0.0",
  "main": "index.html",
  "host": [
    /* ... */
  ],
  "manifestVersion": 4,
  "entrypoints": [
    {
      "type": "panel",
      "id": "vanilla",
      // [...]
      "icons": [
        // [...]
      ],
      "label": {
        "default": "Starter Panel"
      }
    }
  ],
  "icons": [
    // [...]
  ]
}
`}</code></pre>
    <p>{`When Photoshop loads the plugin, it loads the `}<inlineCode parentName="p">{`index.html`}</inlineCode>{` file specified here. The `}<inlineCode parentName="p">{`index.html`}</inlineCode>{` file, in turn, defines
our panel's UI:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<!DOCTYPE html>
<html>
  <head>
    <script src="index.js"></script>
  </head>
  <style>
    /* [...] */
  </style>
  <body>
    <sp-heading>Layers</sp-heading>
    <sp-body id="layers"> No layers </sp-body>
    <footer>
      <sp-button id="btnPopulate">Populate Layers</sp-button>
    </footer>
  </body>
</html>
`}</code></pre>
    <p>{`As you can see, the `}<inlineCode parentName="p">{`index.html`}</inlineCode>{` file then loads the `}<inlineCode parentName="p">{`index.js`}</inlineCode>{`.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert"></InlineAlert>
    <p>{`Note that while this looks like fairly standard HTML, the UXP environment is not a browser and only supports a `}<a parentName="p" {...{
        "href": "/photoshop/uxp/src/pages/uxp/reference-html/General/Unsupported%20Elements.md"
      }}>{`subset of HTML/CSS/JS features`}</a>{`. You can also see some custom components like `}<inlineCode parentName="p">{`<sp-heading>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<sp-body>`}</inlineCode>{`, and `}<inlineCode parentName="p">{`<sp-button>`}</inlineCode>{`. These are so-called `}<a parentName="p" {...{
        "href": "/photoshop/uxp/src/pages/uxp/reference-spectrum/index.md"
      }}>{`Spectrum UXP components`}</a>{` that implement the Spectrum Design system and allow plugins to feel native in the surrounding Photoshop environment.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`index.js`}</inlineCode>{` file then sets up a `}<inlineCode parentName="p">{`click`}</inlineCode>{` listener on the `}<em parentName="p">{`"Populate
Layers"`}</em>{` button and uses the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/photoshop/uxp/2022/ps_reference/"
      }}>{`Photoshop API`}</a>{` to populate the `}<inlineCode parentName="p">{`<sp-body id="layers" />`}</inlineCode>{` element with the layer names:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function showLayerNames() {
  const app = window.require("photoshop").app;
  const allLayers = app.activeDocument.layers;
  const allLayerNames = allLayers.map((layer) => layer.name);
  const sortedNames = allLayerNames.sort((a, b) =>
    a < b ? -1 : a > b ? 1 : 0
  );
  document.getElementById("layers").innerHTML = \`
      <ul>\${sortedNames.map((name) => \`<li>\${name}</li>\`).join("")}</ul>\`;
}

document
  .getElementById("btnPopulate")
  .addEventListener("click", showLayerNames);
`}</code></pre>
    <p>{`Note that you can use the `}<inlineCode parentName="p">{`window.require()`}</inlineCode>{` function to import various API modules, like `}<inlineCode parentName="p">{`require('photoshop')`}</inlineCode>{` in this
example.`}</p>
    <h2 {...{
      "id": "step-3-adjust-the-plugin"
    }}>{`Step 3: Adjust the plugin`}</h2>
    <p><em parentName="p">{`We could call this good enough, but let's face it: This doesn't feel like you've built your own
plugin. So let us at least add some customization to it by adding additional information about our layer to the output.`}</em></p>
    <p>{`Have a look at the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/src/pages/ps_reference/classes/layer.md"
      }}><inlineCode parentName="a">{`Layer`}</inlineCode>{` class API Reference`}</a>{`. This page lists all the
properties and functions available on a layer object. You can choose whatever property you want, but for this tutorial,
we will just use the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/src/pages/ps_reference/classes/layer.md#properties"
      }}><inlineCode parentName="a">{`opacity: number`}</inlineCode>{` property`}</a>{`.`}</p>
    <p>{`Adjust the `}<inlineCode parentName="p">{`main.js`}</inlineCode>{` to also include the new property in the output:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function showLayerNames() {
  // [...]
  const allLayerNames = allLayers.map(
    (layer) => \`\${layer.name} (\${layer.opacity} %)\`
  );
  // [...]
}

// [...]
`}</code></pre>
    <p>{`With your `}<inlineCode parentName="p">{`main.js`}</inlineCode>{` file saved, you need to reload the plugin to run the plugin including your changes. You can do this
by selecting the `}<em parentName="p">{`"••• > Reload"`}</em>{` option in the UXP Developer Tool.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert"></InlineAlert>
    <p>{`If you change anything in the `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` file, you need to do a full reload of the plugin to reflect the changes.
To do this, first select `}<em parentName="p">{`"Unload"`}</em>{` and then `}<em parentName="p">{`"Load"`}</em>{` in the UXP Developer Tool.`}</p>
    <p>{`Alternatively, you can also watch your plugin folder for changes to reload the plugin automatically whenever you change
something. To do so, run the `}<em parentName="p">{`"Watch"`}</em>{` option in your plugin actions menu in the UDT.`}</p>
    <p>{`Back in Photoshop, when you click `}<em parentName="p">{`"Populate Layers"`}</em>{` again, you should see that your property is now also included in
the output:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "262px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "144.27480916030535%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/76d8aa644644bf60f613ddd8d3d8c585/a88cd/panel-with-opacity.webp 262w"],
            "sizes": "(max-width: 262px) 100vw, 262px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/76d8aa644644bf60f613ddd8d3d8c585/8ff13/panel-with-opacity.png 262w"],
            "sizes": "(max-width: 262px) 100vw, 262px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/76d8aa644644bf60f613ddd8d3d8c585/8ff13/panel-with-opacity.png",
            "alt": "A Photoshop panel showing a list of layers including their opacity and a button called \"Populate Layers\"",
            "title": "A Photoshop panel showing a list of layers including their opacity and a button called \"Populate Layers\"",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "next-steps"
    }}>{`Next steps`}</h2>
    <p>{`You've now built your first own plugin. It doesn't look like much right now, but by taking a look at what's available in the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/src/pages/ps_reference/index.md"
      }}>{`API Reference`}</a>{`, you can already do a lot of things with the knowledge of this tutorial, alone.`}</p>
    <p><a parentName="p" {...{
        "href": "../editing-the-document/index.md"
      }}>{`In the next tutorial`}</a>{`, you'll learn how you can not only get information about your document, but actually make changes to it, as well.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      